// extracted by mini-css-extract-plugin
export default {"modal":"DisableModal_modal__6rHEh","label":"DisableModal_label__c+i--","title":"DisableModal_title__ZHEkY"};